import { currentLocale } from './currentLocale'
import { Lang } from './i18n'
import { registerLanguages } from './registerLanguages'
import { locale } from 'svelte-i18n'

export function preselectLang(tenantId: string) {
	currentLocale.load().then(async (currentLang: string) => {
		if (currentLang && currentLang !== Lang.en) {
			await registerLanguages(tenantId)
			locale.set(currentLang)
		}
	})
}
